module.exports = __webpack_public_path__ + "img/advantages-1.fabaaa68.svg";